import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../../components/table/ResultTable";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import {useModal} from "../../../context/ModalContext";
import EmptyLine from "../EmptyLine";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultBody from "../../../components/table/ResultBody";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function C2({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()

    switch (row.error_id) {
        case MessageCodes.Compare.CXS02.error_id: {
            return (
                <>
                    <ResultText>
                        There is a difference in the topography (Station/Elevation data) of the following {Array.from(new Set(row.data?.map(x => x.cross_section)))?.length} cross sections:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => ({
                            csName: x.cross_section,
                            csNameVal: x.cross_section,
                        }))} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.IS03.error_id: {
            const cs_list = Array.from(new Set(row?.data?.map(x => x.cross_section)))
            // Get unique profile names from data
            const profile_list = Array.from(new Set(row?.data?.map(x => x.profile)))
            
            // Build data map: {cross_section: {profile: diff, ...}, ...}
            const dataMap = {}
            row?.data?.forEach(item => {
                if (!dataMap[item.cross_section]) {
                    dataMap[item.cross_section] = {}
                }
                dataMap[item.cross_section][item.profile] = item.diff
            })
            
            return (
                <>
                    <ResultText>
                        The differences in the topography (Station/Elevation data) of the following {cs_list?.length} cross sections are significant and likely to cause some difference in the WSEL for the listed profiles. The percentage values in the table denote the change in flow area at the cross section for the listed profile.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{textAlign: 'left', verticalAlign: 'bottom', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell colSpan={profile_list.length} style={{textAlign: 'center'}}>Change in Flow Area (%)</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                {profile_list.map(profile => (
                                    <ResultHeaderCell key={profile} style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>{profile}</ResultHeaderCell>
                                ))}
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                cs_list?.map(cs => (
                                    <ResultRow key={cs}>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <ComparisonCSName csName={cs} />
                                        </ResultBodyCell>
                                        {profile_list.map(profile => (
                                            <ResultBodyCell key={profile} style={{textAlign: 'right'}}>
                                                {dataMap[cs]?.[profile] ?? '-'}
                                            </ResultBodyCell>
                                        ))}
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.CXS02IB.error_id: {
            return (
                <>
                    <ResultText>
                        There is a difference in the topography (Station/Elevation data) of the following {Array.from(new Set(row.data?.map(x => x.cross_section)))?.length} Internal Bridge Cross Sections:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}